'use strict';

module.exports = ['$scope', '$mdDialog', '$http', '$timeout', '$mdToast','$sce',
	function ($scope, $mdDialog, $http, $timeout, $mdToast, $sce) {

		$scope.close = () => {
			$mdDialog.hide();
		};

		let firstEmail = false;

		$scope.checkMessages = (pageNumber = 1, cb) => {

			const requests = [];

			requests.push(
				$http.get('/usersettings').then((request) => {

					let notificationsByMail = request.data.sendNotificationsByEmail;

					if (typeof notificationsByMail !== 'undefined') {
						$scope.emailSwitch = notificationsByMail;
					} else {
						firstEmail = true;
					}

				})
			);

			requests.push(
				$http.get('/usernotifications/?page=' + pageNumber).then((response) => {
					$scope.messages = response.data;
					$scope.messages.resultPerPage = $scope.messages.per_page;
					$scope.messages.totalResults = $scope.messages.total;
					$scope.messages.current = $scope.messages.current_page;
					$scope.totalTitle = null;
					$scope.totalMessage = null;
					$scope.setMessage(null);
				})
			);

			if (cb) {
				Promise.all(requests)
					.then(() => cb());
			}
		};

		$scope.setMessage = ($index, $message) => {
			if ($index === null || $index === -1) {
				$scope.activeMessage = $index;
				$scope.totalTitle = '';
				$scope.messageFrom = '';
				$scope.totalMessage = '';
			} else {
				$scope.activeMessage = $index;
				$scope.totalTitle = $message.data.title;
				$scope.messageFrom = $message.data.user_full_name || "Pluxbox";
				$scope.totalMessage = $sce.trustAsHtml($message.data.message)
				$scope.read($message);
			}
		};

		$scope.setMessage(null);

		$scope.newMessage = () => {
			$scope.setMessage(-1);
			makeNewMessageContent();
		};

		const prevText = [];

		function getText(content) {
			if (prevText[0] !== content) {
				const container = document.createElement('_');
				prevText[0] = content;
				container.innerHTML = content;
				prevText[1] = container.innerText
					.replace(/[\s\t]+/g, '');
			}
			return prevText[1];
		}

		$scope.checkInput = () => {
			const {newMessageContent} = $scope;
			$scope.isDisabled = (
				newMessageContent.title.length === 0 ||
				newMessageContent.messageTo.length === 0 ||
				getText(newMessageContent.message).length === 0
			);
		};

		$scope.publishMessage = () => {
			const {newMessageContent} = $scope;
			$http.post('/usernotification', {
				to: newMessageContent.messageTo,
				title: newMessageContent.title,
				content: newMessageContent.message,
				from: $scope.messageFrom,
			}).then(response => {
				$mdToast.show({
					templateUrl: '/partial/app.partials.toasts.send?object=notification',
					hideDelay: 3000,
					position: ('top right')
				});
				$scope.checkMessages(1, () => {
					$scope.$applyAsync(() => {
						$scope.setMessage(null);
					});
				});
			});
		};

		$scope.delete = ($id) => {
			$http.delete('/usernotifications/' + $id);
			if (Array.isArray($scope.messages)) {
				$scope.messages = $scope.messages
					.filter(m => (m && m.id !== $id));
			}
			$timeout(function () {
				$scope.checkMessages();
			}, 500);
		};

		$scope.read = ($message) => {
			$http.post('/usernotifications/' + $message.id).then((response) => {
				$message.read_at = response.data;
			});
		};

		$scope.saveSettings = () => {
			let sendByMail = $scope.emailSwitch;

			if (sendByMail) {
				$http.post('/usersettings/', {
					sendNotificationsByEmail: sendByMail
				});
			} else {
				$http.post('/usersettings/', {
					sendNotificationsByEmail: sendByMail
				});
			}
		};

		$scope.checkMessages();

		function checkForElement(elName) {
			return new Promise((resolve) => {
				let bindOnElement = () => {
					let bindOnEl = angular.element(elName);
					if (bindOnEl.length > 0) {
						resolve(bindOnEl);
					} else {
						setTimeout(bindOnElement, 100);
					}
				};

				bindOnElement();
			})
		}

		$scope.search = query => {
			return $http.get('/users-roles/' + encodeURIComponent(query))
				.then(result => {
					return result.data;
				});
		};

		$scope.add = value => {

			if (typeof value === 'string') {
				return null;
			}

			const {newMessageContent} = $scope;
			const checkVal = JSON.stringify([value.type, value.id]);
			let find = newMessageContent.messageTo.find(element => (
				checkVal === JSON.stringify([element.type, element.id])
			));

			if (!find) {
				newMessageContent.messageTo.push({
					type: value.type,
					id: value.id,
					name: value.type === 'user'
						? `${value.firstname} ${value.lastname}`
						: value.name,
				});
			}

			return null;
		};

		$scope.remove = index => {
			const {newMessageContent} = $scope;
			newMessageContent.messageTo.splice(index, 1);
		};


		function makeNewMessageContent() {
			$scope.newMessageContent = {
				messageTo: [],
				title: '',
				message: '',
			};
			$scope.checkInput();
		}

		makeNewMessageContent();


	}
];

